import { useTranslation } from 'react-i18next'

import { ApplicationAccountUserRole } from '@/common/models/applicationAccountUser'
import { z } from '@/lib/zod'

export const NewApplicationAccountUserSchema = () => {
  const { t } = useTranslation('sso')

  return z.object({
    accesses: z.array(
      z.object({
        accountId: z.string().optional(),
        role: z.nativeEnum(ApplicationAccountUserRole, {
          message: t('access.drawer_manage_user_access.schema.role.required'),
        }),
        __isNew: z.boolean().optional(),
        __id: z.string().optional(),
      }),
    ),
  })
}

export type NewApplicationAccountUserForm = z.infer<
  ReturnType<typeof NewApplicationAccountUserSchema>
>
